(function () {
  const DURATION = 1400;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function parseValue(raw) {
    const match = raw.match(/^([+\-]?)(\d+\.?\d*)(.*)$/);
    if (!match) return null;
    return {
      prefix: match[1],
      number: parseFloat(match[2]),
      suffix: match[3],
    };
  }

  function animateStat(el) {
    const raw = el.dataset.statTarget;
    if (!raw) return;

    const parsed = parseValue(raw);
    if (!parsed) return;

    const { prefix, number, suffix } = parsed;
    const isFloat = raw.includes('.');
    const start = performance.now();

    function frame(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / DURATION, 1);
      const eased = easeOutCubic(progress);
      const current = eased * number;

      el.textContent = prefix + (isFloat ? current.toFixed(1) : Math.round(current)) + suffix;

      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = raw;
      }
    }

    requestAnimationFrame(frame);
  }

  function init() {
    const sections = document.querySelectorAll('[data-stats-section]');
    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          entry.target.querySelectorAll('[data-stat-target]').forEach(animateStat);
        });
      },
      { threshold: 0.3 }
    );

    sections.forEach((section) => observer.observe(section));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
